// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = <F extends (...args: any[]) => any>(
  fn: F,
  timeout: number,
): ((...args: Parameters<F>) => void) & { cancel: () => void } => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const debounced = (...args: Parameters<F>): void => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), timeout);
  };
  // Drops a pending call, so an unmounted owner never fires a stale callback.
  debounced.cancel = (): void => clearTimeout(timer);
  return debounced;
};
